module.exports = __webpack_public_path__ + "img/check-big.0f95afc8.svg";